let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("5g5GD"), load("5HsIb"), load("c6MKV"), load("aZinD"), load("4Pn6Z"), load("lMnCe")]).then(() => parcelRequire('5XJaz'));